export function setDocumentTitleForPrintPreview(tempTitle: string): () => void {
  const previousTitle = document.title;
  document.title = tempTitle;
  return () => {
    document.title = previousTitle;
  };
}


